var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRuby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    viewBox: "0 0 198.13 197.58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 174.074,
    y1: 215.549,
    x2: 132.276,
    y2: 141.753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e42b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 194.895,
    y1: 153.558,
    x2: 141.028,
    y2: 117.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 151.795,
    y1: 217.785,
    x2: 97.93,
    y2: 181.638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 38.696,
    y1: 127.391,
    x2: 47.047,
    y2: 181.661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#de3b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 96.133,
    y1: 76.715,
    x2: 99.21,
    y2: 132.102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e4714e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#be1a0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 147.103,
    y1: 25.521,
    x2: 156.314,
    y2: 65.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 118.976,
    y1: 11.541,
    x2: 158.669,
    y2: -8.305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c81f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bf0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 3.903,
    y1: 113.555,
    x2: 7.17,
    y2: 146.263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#de4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bf190b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf190b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: -18.556,
    y1: 155.105,
    x2: 135.015,
    y2: -2.809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c82f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 99.075,
    y1: 171.033,
    x2: 52.818,
    y2: 159.617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c0c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c0c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: 178.526,
    y1: 115.515,
    x2: 137.433,
    y2: 78.684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e110b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e110b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9e0c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: 193.624,
    y1: 47.937,
    x2: 173.154,
    y2: 26.054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9e120b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e120b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__p",
    gradientUnits: "userSpaceOnUse",
    x1: 26.67,
    y1: 197.336,
    x2: 9.989,
    y2: 140.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9e100a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b3100c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3100c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__q",
    gradientUnits: "userSpaceOnUse",
    x1: 154.641,
    y1: 9.798,
    x2: 192.039,
    y2: 26.306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910f08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791c12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 141.753,
    x2: 132.276,
    y1: 215.549,
    x1: 174.074,
    gradientUnits: "userSpaceOnUse",
    id: "ruby_svg__b",
    xlinkHref: "#ruby_svg__a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby_svg__n",
    cx: 143.832,
    cy: 79.388,
    r: 50.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7e0e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e0e08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby_svg__o",
    cx: 74.092,
    cy: 145.751,
    r: 66.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a30c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a30c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800e08"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__b)",
    fillRule: "evenodd",
    d: "M153.5 130.41L40.38 197.58l146.469-9.939L198.13 39.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__c)",
    fillRule: "evenodd",
    d: "M187.089 187.54L174.5 100.65l-34.291 45.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__d)",
    fillRule: "evenodd",
    d: "M187.259 187.54L95.03 180.3l-54.16 17.091z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__e)",
    fillRule: "evenodd",
    d: "M41 197.41l23.04-75.48-50.7 10.841z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__f)",
    fillRule: "evenodd",
    d: "M140.2 146.18L119 63.14l-60.67 56.87z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__g)",
    fillRule: "evenodd",
    d: "M193.32 64.31l-57.35-46.84L120 69.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__h)",
    fillRule: "evenodd",
    d: "M166.5.77l-33.73 18.64L111.49.52z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "url(#ruby_svg__i)",
    fillRule: "evenodd",
    d: "M0 158.09l14.13-25.77-11.43-30.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.94 100.65l11.5 32.62 49.97-11.211 57.05-53.02 16.1-51.139L111.209 0l-43.1 16.13C54.53 28.76 28.18 53.75 27.23 54.22c-.94.48-17.4 31.59-25.29 46.43z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M42.32 42.05c29.43-29.18 67.37-46.42 81.93-31.73 14.551 14.69-.88 50.39-30.31 79.56s-66.9 47.36-81.45 32.67c-14.56-14.68.4-51.33 29.83-80.5z",
    fill: "url(#ruby_svg__j)",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M41 197.38l22.86-75.72 75.92 24.39c-27.45 25.74-57.98 47.5-98.78 51.33z",
    fill: "url(#ruby_svg__k)",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M120.56 68.89l19.49 77.2c22.93-24.11 43.51-50.03 53.589-82.09l-73.079 4.89z",
    fill: "url(#ruby_svg__l)",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M193.44 64.39c7.8-23.54 9.6-57.31-27.181-63.58l-30.18 16.67 57.361 46.91z",
    fill: "url(#ruby_svg__m)",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 157.75c1.08 38.851 29.11 39.43 41.05 39.771L13.47 133.11 0 157.75z",
    fill: "#9e1209",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M120.669 69.01c17.62 10.83 53.131 32.58 53.851 32.98 1.119.63 15.31-23.93 18.53-37.81l-72.381 4.83z",
    fill: "url(#ruby_svg__n)",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M63.83 121.66l30.56 58.96c18.07-9.8 32.22-21.74 45.18-34.53l-75.74-24.43z",
    fill: "url(#ruby_svg__o)",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.35 133.19l-4.33 51.56c8.17 11.16 19.41 12.13 31.2 11.26-8.53-21.23-25.57-63.68-26.87-62.82z",
    fill: "url(#ruby_svg__p)",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M135.9 17.61l60.71 8.52C193.37 12.4 183.42 3.54 166.46.77L135.9 17.61z",
    fill: "url(#ruby_svg__q)",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "static/media/ruby.ac68d09b.svg";
export { SvgRuby as ReactComponent };